const colorArray = ["#3B7FA8", "#26648B", "#265674", "#1a2a3f", "#3a4856"];

export { colorArray };
